// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgf_a bhb_bi"};